import { MutationFunction, useMutation } from "@tanstack/react-query";
import { client } from "@johnpaul/jp-api-client";
import { getClientToken } from "@companion-core/shared/app/Utils/apiClient";

type AssistanceVariables = {
  payload: Record<string, unknown>;
};

export function useAssistance(onError?: () => void) {
  const mutationFn: MutationFunction<unknown, AssistanceVariables> = async ({ payload }) => {
    await getClientToken();
    return await client.auth.assistance(payload);
  };

  return useMutation({
    mutationFn,
    retry: false,
    gcTime: 0,
    onError: onError ? onError : undefined,
  });
}
